import { useEffect, useRef, useState } from 'react';
import QRCode from 'qrcode';

export default function SubscriptionQr({ payload, size = 168, fallbackText }) {
  const canvasRef = useRef(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setFailed(false);
    if (!payload || !canvasRef.current) {
      return undefined;
    }
    Promise.resolve(
      QRCode.toCanvas(canvasRef.current, payload, {
        width: size,
        margin: 1,
        errorCorrectionLevel: 'M',
      })
    ).catch(() => {
      if (!cancelled) {
        setFailed(true);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [payload, size]);

  if (!payload) {
    return null;
  }

  if (failed) {
    return (
      <p className="singbox-qr-fallback" role="status">
        {fallbackText || 'QR could not be drawn. Use the HTTPS subscription link.'}
      </p>
    );
  }

  return (
    <canvas
      ref={canvasRef}
      className="singbox-qr"
      width={size}
      height={size}
      aria-label="QR for sing-box"
    />
  );
}
